import React, { useEffect, useState, useRef, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button } from 'react-bootstrap';
import { BASEAPIURL, token } from '../../env';

const FacilityManager = () => {
  const [facilities, setFacilities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [form, setForm] = useState({
    FacilityName: '',
    FacilityDescShort: '',
    FacilityDescLong: '',
  });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [existingImages, setExistingImages] = useState([]);
  const fileInputRef = useRef(null);
  const tokenData = token;

  const sanitize = (text) =>
    typeof text === 'string'
      ? text
        .split('')
        .filter((char) => {
          const code = char.charCodeAt(0);
          return (code >= 32 && code <= 126) || code > 160;
        })
        .join('')
        .trim()
      : '';

  const cleanJSONText = (value) => {
    try {
      if (typeof value === 'string' && (value.startsWith('"') || value.startsWith('\\"'))) {
        return JSON.parse(value);
      }
      return value;
    } catch {
      return value;
    }
  };

  const fetchFacilities = useCallback(async () => {
    if (!tokenData) {
      alert('Authentication token is missing. Please log in.');
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${BASEAPIURL}/GetFGrpList?Token=${encodeURIComponent(token)}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (res.status === 204) {
        setFacilities([]);
        return;
      }

      const resData = await res.json();
      const parsedData = (Array.isArray(resData) ? resData : resData?.data || []).map((item) => ({
        ...item,
        FacilityDescShort: cleanJSONText(item.FacilityDescShort),
        FacilityDescLong: cleanJSONText(item.FacilityDescLong),
      }));

      setFacilities(parsedData);
    } catch (err) {
      console.error('Fetch facilities error:', err);
      alert('Failed to load facilities. Please try again later.');
    } finally {
      setLoading(false);
    }
  }, [tokenData]);

  useEffect(() => {
    fetchFacilities();
  }, [fetchFacilities]);

  const resetForm = () => {
    setForm({
      FacilityName: '',
      FacilityDescShort: '',
      FacilityDescLong: '',
    });
    setSelectedFiles([]);
    setExistingImages([]);
    if (fileInputRef.current) fileInputRef.current.value = '';
    setIsEdit(false);
  };

  const urlToBlob = async (url) => {
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`Failed to fetch image from ${url}`);
      const blob = await res.blob();
      return new File([blob], url.substring(url.lastIndexOf('/') + 1), { type: blob.type });
    } catch (err) {
      console.error('urlToBlob error:', err);
      return null;
    }
  };

  const removeExistingImage = (index) => {
    const updated = [...existingImages];
    updated.splice(index, 1);
    setExistingImages(updated);
  };

  const removeSelectedFile = (index) => {
    const updated = [...selectedFiles];
    updated.splice(index, 1);
    setSelectedFiles(updated);
  };

  const handleSubmit = async () => {
    if (submitting) return;
    if (!form.FacilityName.trim()) {
      alert('Facility Group Name is required');
      return;
    }

    setSubmitting(true);
    try {
      let uploadSuccess = true;

      // if (selectedFiles.length > 0 || existingImages.length > 0) {
        const formdata = new FormData();
        formdata.append('token', tokenData);
        formdata.append('FacilityGroupID', form.FacilityGroupID ?form.FacilityGroupID : 0);
        formdata.append('FacilityName', form.FacilityName);
        formdata.append('FacilityDescShort',form.FacilityDescShort)
        formdata.append('FacilityDescLong',form.FacilityDescLong)
        

        for (const url of existingImages) {
          const file = await urlToBlob(url);
          if (file) formdata.append('FacilityImages', file, file.name);
        }

        for (const file of selectedFiles) {
          formdata.append('FacilityImages', file, file.name);
        }

        const uploadRes = await fetch(`${BASEAPIURL}/UploadFGrp`, {
          method: 'POST',
          body: formdata,
        });

        const uploadText = await uploadRes.text();
        console.log('📤 Upload response:', uploadText);

        let uploadResult;
        try {
          uploadResult = uploadText ? JSON.parse(uploadText) : {};
        } catch (err) {
          throw new Error('Invalid upload response');
        }

        uploadSuccess =
          uploadRes.status === 200 &&
          (uploadResult.status === true || uploadResult.status === 'true');

        if (!uploadSuccess) {
          throw new Error(uploadResult.message || 'Image upload failed');
        }
      // }

      if (!uploadSuccess) {
        alert('Image upload failed. Aborting.');
        setSubmitting(false);
        return;
      }

      if (isEdit && !form.FacilityGroupID) {
        alert('FacilityGroupID missing — cannot perform update.');
        setSubmitting(false);
        return;
      }

      const payload = {
        tokenData,
        FGrp: {
          FacilityName: sanitize(form.FacilityName),
          FacilityDescShort: sanitize(form.FacilityDescShort),
          FacilityDescLong: sanitize(form.FacilityDescLong),
        },
      };

      // if(isEdit === false){
      //       const url = `${BASEAPIURL}/InsertFGrp`;
      // // isEdit? `${BASEAPIURL}/UpdateFGrp?FGrpID=${form.FacilityGroupID}`: ;

      // const res = await fetch(url, {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify(payload),
      // });

      // const text = await res.text();
      // console.log('📥 Server response text:', text);

      // try {
      //   JSON.parse(text);
      // } catch (err) {
      //   throw new Error('Invalid server response');
      // }
      // }
     

      alert(`Facility ${isEdit ? 'updated' : 'added'} successfully`);
      resetForm();
      setShowModal(false);
      fetchFacilities();
    } catch (error) {
      console.error('❌ Submit error:', error);
      alert(`Error ${isEdit ? 'updating' : 'adding'} facility: ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">Facilities</h2>
        <button className="btn btn-dark" onClick={() => { resetForm(); setShowModal(true); }}>
          + Add Facility Group
        </button>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? 'Edit' : 'Add'} Facility</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Facility Group Name</label>
            <input
              type="text"
              className="form-control"
              value={form.FacilityName}
              onChange={(e) => setForm({ ...form, FacilityName: e.target.value })}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Short Description</label>
            <input
              type="text"
              className="form-control"
              value={form.FacilityDescShort}
              onChange={(e) => setForm({ ...form, FacilityDescShort: e.target.value })}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Long Description</label>
            <textarea
              className="form-control"
              rows={4}
              value={form.FacilityDescLong}
              onChange={(e) => setForm({ ...form, FacilityDescLong: e.target.value })}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Upload Images</label>
            <input
              type="file"
              ref={fileInputRef}
              className="form-control"
              multiple
              accept="image/*"
              onChange={(e) => {
                const files = Array.from(e.target.files);
                const maxSize = 5 * 1024 * 1024; // 5 MB in bytes
                const validFiles = [];
                const tooLarge = [];

                files.forEach((file) => {
                  if (file.size <= maxSize) {
                    validFiles.push(file);
                  } else {
                    tooLarge.push(file.name);
                  }
                });

                if (tooLarge.length > 0) {
                  setErrorMsg(`❌ These files exceed 5 MB: ${tooLarge.join(", ")}`);
                } else {
                  setErrorMsg(""); // clear if no error
                }

                setSelectedFiles(validFiles);
              }}
            />

            {/* 🔹 Error message displayed below input */}
            {errorMsg && (
              <div className="text-danger mt-2 fw-semibold">
                {errorMsg}
              </div>
            )}
          </div>

          {selectedFiles.length > 0 && (
            <div className="mt-2">
              <label>Selected Images:</label>
              <div className="d-flex flex-wrap gap-2 mt-1">
                {selectedFiles.map((file, idx) => (
                  <div key={idx} style={{ position: 'relative' }}>
                    <img
                      src={URL.createObjectURL(file)}
                      alt="Preview"
                      style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 5 }}
                    />
                    <button
                      onClick={() => removeSelectedFile(idx)}
                      className="btn btn-sm btn-danger position-absolute top-0 end-0"
                      style={{ borderRadius: '50%', padding: '2px 6px', fontSize: '12px' }}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {isEdit && existingImages.length > 0 && (
            <div className="mt-2">
              <label>Existing Images:</label>
              <div className="d-flex flex-wrap gap-2 mt-1">
                {existingImages.map((imgUrl, idx) => (
                  <div key={idx} style={{ position: 'relative' }}>
                    <img
                      src={imgUrl}
                      alt="Facility"
                      style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 5 }}
                    />
                    <button
                      onClick={() => removeExistingImage(idx)}
                      className="btn btn-sm btn-danger position-absolute top-0 end-0"
                      style={{ borderRadius: '50%', padding: '2px 6px', fontSize: '12px' }}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={handleSubmit} disabled={submitting}>
            {submitting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" /> Saving...
              </>
            ) : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>

      {loading ? (
        <div className="text-center">
          <div className="spinner-border" role="status" />
        </div>
      ) : facilities.length === 0 ? (
        <div className="text-center">
          <p>No facilities found.</p>
        </div>
      ) : (
        <div className="table-responsive mt-4">
          <table className="table table-bordered align-middle table-striped">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Group ID</th>
                <th>Short Desc</th>
                <th>Long Desc</th>
                <th>Images</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {facilities.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.FacilityName}</td>
                  <td>{item.FacilityGroupID}</td>
                  <td>{cleanJSONText(item.FacilityDescShort)}</td>
                  <td>{cleanJSONText(item.FacilityDescLong)}</td>
                  <td>
                    <div className="d-flex flex-wrap gap-1">
                      {(item.FacilityImages || []).map((imgUrl, i) => (
                        <img
                          key={i}
                          src={imgUrl}
                          alt="Facility"
                          style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 4 }}
                        />
                      ))}
                    </div>
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => {
                        setForm({
                          FacilityGroupID: item.FacilityGroupID || '',
                          FacilityName: item.FacilityName || '',
                          FacilityDescShort: cleanJSONText(item.FacilityDescShort) || '',
                          FacilityDescLong: cleanJSONText(item.FacilityDescLong) || '',
                        });
                        setSelectedFiles([]);
                        setExistingImages(item.FacilityImages || []);
                        if (fileInputRef.current) fileInputRef.current.value = '';
                        setIsEdit(true);
                        setShowModal(true);
                      }}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default FacilityManager;